export default __webpack_public_path__ + "static/media/Brow_4_C2.925b8164.svg";